"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var tslib_1 = require("tslib");
var colors_1 = tslib_1.__importDefault(require("./colors"));
exports.theme = {
    name: 'FOS Default Theme',
    animations: {
        normalTransition: 'all 0.125s cubic-bezier(0, 0, 0.25, 1)',
    },
    breakpoints: {
        desktop: '1024px',
        mobile: '450px',
        tablet: '850px',
    },
    colors: colors_1.default,
    controlSizes: {
        large: '5rem',
        medium: '3.2rem',
        small: '1rem',
        xsmall: '1.2rem',
        xxsmall: '0.75rem',
    },
    dataVizSettings: {
        height: '6.7rem',
    },
    fonts: {
        robotoBold: '"Roboto Bold", sans-serif',
        robotoLight: '"Roboto Light", sans-serif',
        robotoMedium: '"Roboto Medium", sans-serif',
        robotoRegular: '"Roboto Regular", sans-serif',
        robotoMonoRegular: '"Roboto Mono Regular"',
        robotoMonoBold: '"Roboto Mono Bold"',
    },
    fontSizes: {
        actionMenu: {
            item: '1.3rem',
            label: '1.2rem',
        },
        datePicker: {
            header: '1.5rem',
        },
        elements: {
            button: '1.2rem',
            buttonIcon: '1.3rem',
            checkbox: '1.6rem',
        },
        footer: {
            navigation: '1.2rem',
        },
        grid: {
            data: '1.4rem',
            header: '1.2rem',
        },
        header: {
            actionIcon: '2.4rem',
            navigation: '1.2rem',
            title: '1.8rem',
        },
        settingsPanel: {
            benchmarkLeft: '1.4rem',
            panelTitle: '1.8rem',
            sectionLabel: '1.8rem',
            tabLabel: '1.5rem',
        },
        subheader: {
            viewDimensions: '1.3rem',
            viewTitle: '2.4rem',
        },
    },
    letterSpacing: '.05rem',
    transitions: {
        normalDuration: 300,
    },
};
